export default __webpack_public_path__ + "guide--raster-naip-in-studio-960-b43f53ec94f7db0bc056ab549e07d27c.png";